import { apiClient } from "./apiClient";

export async function fetchCostRefSearch({ queryKey }) {
    const [_key, query] = queryKey;
    const response = await apiClient(`/api/agent/costref_search/?search=${encodeURIComponent(query)}`, {
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include',
    });

    return response.json();
}
